/**
@author : Nikhil 

Used to render list of application chevrons 
Usage:  <div jv-application-chevron obj="otherApp" index="$index"></div>

otherApp = Application Object 
index is the index of the application in the list. Can be 0 for single application

@include applicationChevron.scss for chevron styles
**/
angular.module('jv.application.chevron.directive', [])
.controller('jvApplicationChevronController',['$scope', 'jvCandidatesService',
        function($scope, jvCandidatesService) {
            
            $scope.init =  function () {
                $scope.workflowUpdates = [];
            };
            $scope.init();
            
            $scope.getWorkflowUpdates = function(index, applicationId){
                var args = {
                    applicationId: applicationId,
                    readMode: 1
                };
                jvCandidatesService.getWorkflowUpdates(args, function(response) {
                    $scope.workflowUpdates[index] = response.data.applicationWorkflowUpdates;
                });
            };

            $scope.numberOfSteps = function(){
                return new Array(4);
            };

            $scope.isRejected = function(appObj, workflowIndicator, index){
                var indexFrom1 = index+1;
                var name = "Step" + indexFrom1;
                if (workflowIndicator && workflowIndicator[name]) {
                    if (workflowIndicator[name].rejected) {
                        appObj.dispositionName = workflowIndicator[name].disposition;
                        return true;
                    }
                }
                return false;
            };
            
            $scope.isCurrent = function(workflowIndicator, index) {
                if (angular.isUndefined(workflowIndicator)) {
                    return;
                }
                switch (index) {
                    case 3:
                        if (angular.isDefined(workflowIndicator.Step4))  {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isDefined(workflowIndicator.Step3))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isDefined(workflowIndicator.Step2))  {
                            return true;
                        }
                        break;
                    case 0:
                        if (angular.isDefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                }
                return false;
            };

            $scope.isEmpty = function(workflowIndicator, index) {
                if (angular.isUndefined(workflowIndicator)) {
                    return;
                }
                switch (index) {
                    case 0:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2) && angular.isUndefined(workflowIndicator.Step1))  {
                            return true;
                        }
                        break;
                    case 1:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3) && angular.isUndefined(workflowIndicator.Step2)) {
                            return true;
                        }
                        break;
                    case 2:
                        if (angular.isUndefined(workflowIndicator.Step4) && angular.isUndefined(workflowIndicator.Step3)) {
                            return true;
                        }
                        break;
                    case 3:
                        if (angular.isUndefined(workflowIndicator.Step4)) {
                            return true;
                        }
                        break;
                }
                return false;
            };
}])
.directive('jvApplicationChevron', [
    function() {
        return {
            scope: {
                obj: '=',
                index: "="
            },
            controller: 'jvApplicationChevronController',
            templateUrl: 'directives/applicationChevron.html'
        };
    }
]);
